import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'formatRate',
})
export class FormatRatePipe implements PipeTransform {
  transform(value?: number): string {
    if (value === null) {
      return '-';
    }

    if ((value as number) % 1 === 0) {
      return (value as number).toString();
    }
    return (value as number).toFixed(
      Math.min(4, (value as number).toString().split('.')[1].length)
    );
  }
}
